import React from 'react'
import {Link,Route,Routes,useLocation} from 'react-router-dom'
const User = () => {
    const location=useLocation()
  return (
    <div>
        {/* {location.pathname==='user'&&(
            <nav>
             
            </nav>
        )} */}
    </div>
  )
}

export default User